import { IHttpService } from 'angular';
import { IDatabaseRestoreDescription } from "../../typings/board/Admin";

export const BACKUP_AND_RESTORE_SERVICE = "backupAndRestoreService";
export class BackupAndRestoreService {

    workInProgress = false;
    workInProgressMsg = "";

    static $inject = ["$mdToast", "$q", "$http", "WEB_ENDPOINT"];
    constructor(private $mdToast: ng.material.IToastService, private $q: ng.IQService, private $http: IHttpService, private boardWebEndpoint: string) { }

    availableDatabases() {
        return this.$http.get<string[]>(`${this.boardWebEndpoint}/admin/database/availableDatabases`).then(response => response.data);
    }

    createBackup(databaseName: string) {
        return this.$http.get<string[]>(`${this.boardWebEndpoint}/admin/database/backup`, { params: { databaseName: databaseName } })
            .then((response) => {
                this.workInProgress = false;
                this.$mdToast.show(this.$mdToast.simple().textContent("Backup successfully created!").position("top right"));
                return response.data;
            });
    }

    databaseRestoreList() {
        return this.$http.get<IDatabaseRestoreDescription[]>(`${this.boardWebEndpoint}/admin/database/databaseRestoreList`).then((response) => {
            return response.data;
        }, (reason) => {
            return this.$q.reject(reason);
        });
    }

    restoreBackup(restorePoint: string) {
        return this.$http.get<void>(`${this.boardWebEndpoint}/admin/database/restoreBackup`, { params: { restorePoint: restorePoint } }).then((response) => {
            this.workInProgress = false;
            this.$mdToast.show(this.$mdToast.simple().textContent("Backup successfully restored!").position("top right"));
            return response.data;
        });
    }

}


// WEBPACK FOOTER //
// ./app/backup-and-restore/backup-and-restore.service.ts